import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useGlobalState } from '../../../stateProvider/StateProvider';
import Bar from '../../../charts/Bar';
import { QuestRoute } from '../../../api/QuestRoutes';
import Loading from '../../../Loading';
import HamQuest from '../../../api/HamQuestGiver';
import Col from '../../../layout/Col';
import Row from '../../../layout/Row';
import Input from '../../../forms/Input';
import { beginningOfMonth, between, findLastNonFalsely, inputDate, translate } from '../../../utility/functions';
import Modal from '../../../Modal';
import Select from '../../../forms/Select';
import useDebounce from '../../../utility/debounce';
import ModalFactory from '../../../Modal';

const HourlyBarReport = ({ ...props }) => {
    const {
        state: {
            locations,
            allLocations
        },
    } = useGlobalState();

    const xAxis = [
        '12AM', '1AM', '2AM', '3AM', '4AM', '5AM', '6AM', '7AM',
        '8AM', '9AM', '10AM', '11AM', '12PM', '1PM', '2PM', '3PM',
        '4PM', '5PM', '6PM', '7PM', '8PM', '9PM', '10PM', '11PM'
    ]

    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [tableConfig, setTableConfig] = useState({
        stacked: true,
        xAxisLabel: 'Item Sales',
        xAxis: xAxis,
        data: [{
            name: 'Sales',
            data: tableData,
        }],
    });

    const [location, setLocFilter] = useState('')

    const [dates, setDates] = useState({
        startDate: beginningOfMonth,
        endDate: inputDate()
    })
    const debounced = useDebounce(dates, 1500)

    const updateGraph = (objectsArray) => {
        const trimmedData = Object.values(objectsArray).map(e => e);

        let min = 24, max = 0;
        trimmedData.forEach(({ data }) => {
            const firstIndex = data.findIndex(e => e);
            min = Math.min(min, firstIndex >= 0 ? firstIndex : 24);
            max = Math.max(max, findLastNonFalsely(data));
        });
        min = between(min - 2, 0, 24);
        max = between(max + 3, 0, 24);

        trimmedData.forEach((e) => e.data = e.data.slice(min, max))
        const len = max - min;
        const totals = new Array(len < 0 ? 24 : len).fill().map((e, i) => trimmedData.reduce((a, b) => a + b.data[i], 0))

        setTableConfig(e => {
            return {
                ...e,
                data: trimmedData,
                xAxis: len < 0 ? xAxis : xAxis.slice(min, max).map((e, i) => `${e} (${totals[i]})`)
            }
        })
    }

    useEffect(() => {
        setLoading(true);
        HamQuest.post(QuestRoute.reports.hourlyBar, {
            startDate: dates.startDate,
            endDate: dates.endDate,
            location
        })
            .then(res => {
                setTableData(res);
                updateGraph(res);
            })
            .catch(ModalFactory.catch)
            .finally(() => setLoading(false))
    }, [debounced, location])

    return (
        <Col style={{ width: '100%', height: '60svh' }}>
            <Row wrap>
                <Input
                    label='Start Date'
                    name='startDate'
                    type='date'
                    value={dates.startDate}
                    onInput={e => setDates({
                        ...dates,
                        startDate: e.target.value
                    })}
                    max={dates.endDate}
                    required
                    standalone
                    flex='0'
                />
                <Input
                    label='End Date'
                    name='endDate'
                    type='date'
                    value={dates.endDate}
                    onInput={e => setDates({
                        ...dates,
                        endDate: e.target.value
                    })}
                    min={dates.startDate}
                    required
                    standalone
                    flex='0'
                />
                <Select
                    standalone
                    label='Location Filter'
                    value={location}
                    onChange={e => setLocFilter(e.target.value)}
                    options={[{ value: '', label: 'All Locations' }, ...allLocations]}
                />
                {loading && <Loading style={{ height: '95%', width: '2.5em' }} />}
            </Row>
            <Bar chartProps={tableConfig} />
        </Col>
    );
}

export default HourlyBarReport;